MAP_MODAL_ID = 'directions-and-phone-number-modal'

init = ->
  $mapContainer = $ '#directions-map-canvas'
  centerLat = $mapContainer.data 'center-lat'
  centerLng = $mapContainer.data 'center-lng'

  return unless centerLat and centerLng and $mapContainer.length

  mapOptions =
    center: new google.maps.LatLng(centerLat, centerLng)
    zoom: 15
    zoomControl: true
    zoomControlOptions:
      style: google.maps.ZoomControlStyle.SMALL
      position: google.maps.ControlPosition.LEFT_TOP
    mapTypeControl: false
    disableDefaultUI: true

  map = new google.maps.Map(document.getElementById('directions-map-canvas'), mapOptions)

  isGroupon = not $('body').hasClass('brand-livingsocial') and not $('body').hasClass('brand-gemini')

  if isGroupon
    icon = 'https://img.grouponcdn.com/mpp/hTR9ngReZbjmQWzGbV1g/Wn-27x41.png'
  else
    icon = 'https://img.grouponcdn.com/sls/27C4jDdP1d9mG43yvuWTLpC1BE5S/27-28x43'

  new google.maps.Marker
    position: new google.maps.LatLng(centerLat, centerLng)
    map: map
    icon: icon

onOpen = ->
  $mapContainer = $ '#directions-map-canvas'

  return unless $mapContainer.length

  mapProxyBase = $mapContainer.data 'map-url'

  $merchantActionsModal = $ "##{MAP_MODAL_ID}"
  screenHeight = $(window).height()
  headerHeight = $merchantActionsModal.find('.modal-title').outerHeight()
  merchantActionsHeight = $merchantActionsModal.find('.merchant-actions').outerHeight()

  screenHeight = screenHeight - headerHeight - merchantActionsHeight

  $mapContainer.css 'min-height', screenHeight
  $mapContainer.css 'max-height', screenHeight

  Groupon.Utils.GoogleMaps.load (err) ->
    # TODO: gracefully handle error
    throw err if err?
    init()

$ ->

  # check if modal was open on page load before we could attach the 'modal-open' event
  onOpen() if $("##{MAP_MODAL_ID}.show-modal").length > 0

  $('body').on "modal-open:#{MAP_MODAL_ID}", onOpen

  $('.merchant-actions-container .actions-summary').click (event) ->
    MPP.Modal.open "##{MAP_MODAL_ID}"
